
<template>
  <div class="row gy-2">
    <div class="col-12">
      <h5 class="mb-3">Notifications</h5>
      <div class="row mb-3 gy-2 justify-content-between">
        <div class="col-md-6 col-lg-5 col-xl-4 d-flex">
          <div class="dropdown no-arrow me-2">
            <a class="btn btn-light bg-white dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="bx bx-menu"></i>
            </a>
            <ul class="dropdown-menu">
              <li @click.prevent="deleteItems()">
                <button class="dropdown-item" type="button">
                  Delete Selected
                </button>
              </li>
            </ul>
          </div>
          <div class="input-group">
            <b-form-select style="max-width:100px;" class="form-select" v-model="itemsPerPage" :options="pageOptions"></b-form-select>
            <select @change="fetchItems()" v-model="defaultStatus" class="form-select flex-grow-1">
              <option value="" disabled selected>-filter-</option>
              <option :value="null">Show All</option>
              <option v-for="(status, tIndex) in statusOptions"
                :value="status.value" :key="tIndex" > {{status.label}} </option>
            </select>
          </div>
        </div>
        <div class="col-md-6 col-lg-5">
          <div class="input-group mb-0">
            <input v-model="searchQuery" @input="updateSearchQuery" type="search" class="form-control" placeholder="Search here..." aria-label="Search here..." aria-describedby="button-search_TB">
            <button @click="fetchItems()" class="btn btn-primary" type="button" id="button-search_TB"><span class="ri ri-search-line"></span></button>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <p class="mb-0">Showing {{paginationInfo}} results</p>
      </div>
      <div class="card">
        <div class="card-body p-lg-3">
           <div class="table-responsive mb-0 loading-viewport">
            <is-loading v-if="isLoading" :box="true" />
            <b-table striped hover table-class="table table-centered w-100" thead-tr-class=""
               ref="selectableTable" :items="pageData.data"
               :fields="columns" responsive="sm">
               <template v-for="(column, colIndex) in columns.filter((i) => i.sortable)"
                  v-slot:[`head(${column.key})`] >
                    <div :key="colIndex" @click="setSortOrder(column)" class="cursor-pointer
                    d-flex align-items-center">
                      {{ column.label }} <span v-html="getSortingLabel(column.key)"></span>
                    </div>
                </template>
                <template v-slot:head(check)>
                  <div style="width:3.5rem;" class="form-check text-center">
                    <label class="form-check-label me-2" for="tableSRadioHead">
                      <input @change="selectAllRows($event)" type="checkbox"
                       class="form-check-input" id="tableSRadioHead" />
                    </label>
                  </div>
                </template>
                <template v-slot:cell(check)="data">
                  <div style="width:3.5rem;" class="form-check text-center me-auto">
                    <input v-model="selectedItems" type="checkbox" :value="data.item.id" class="form-check-input me-2"
                     :id="`tableSRadio${data.item.id}`" @click="handleCheckboxClick($event, data.item)" />
                    <label class="form-check-label" :for="`tableSRadio${data.item.id}`"></label>
                  </div>
                </template>
                <template v-slot:cell(title)="data">
                  <div @click="navigateTo(data.item)" style="min-width:13rem;" class="d-inline-block cursor-pointer">
                    <p class="mb-1">
                      <span class="text-dark me-2">{{ data.item.title }}</span>
                      <span v-if="!data.item.is_read" class="badge bg-primary">new</span>
                    </p>
                    <span @click="navigateTo(data.item)" class="text-dark small">{{ data.item.content }}</span>
                  </div>
                </template>
                <template v-slot:cell(created_at)="data">
                    <span class="cursor-pointer" @click="navigateTo(data.item)">{{$filters.date_ago(data.item.created_at)}} </span>
                </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="mb-4">
        <b-pagination v-model="currentPage" :limit="4" class="pagination-rounded"
        :total-rows="pageData.total" :per-page="itemsPerPage"></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import IsLoading from '@/components/IsLoading.vue';
import _ from 'lodash';
import { commonSortingMixin } from '@shared/mixins/commonSortingMixin';
import { commonPaginationMixin } from '@shared/mixins/commonPaginationMixin';
import { commonSelectRowMixin } from '@shared/mixins/commonSelectRowMixin';

export default {
  components: { IsLoading },
  name: "notification-list",
  mixins: [
    commonSortingMixin,
    commonPaginationMixin,
    commonSelectRowMixin
  ],
  data() {
    return {
      isLoading: false,
      defaultStatus: null,
      searchQuery: "",

      statusOptions:[
        { value: "0", label: "Unread"},
        { value: "1", label: "Read"}
      ],

      columns: [
        {
          key: "check",
        },
        {
          key: "title",
          label: "Title",
          sortable: true
        },
        {
          key: "created_at",
          label: "Date Received",
          sortable: true
        },
      ],
      sortBy: {
        sort_column: "created_at",
        sort_direction: "desc"
      },
    }
  },
  computed: {
    pageData() {
      return this.$store.state.notification.pageData
    },
  },
  methods: {
    navigateTo(notif){
      if(!notif.is_read){
        this.$store.dispatch("notification/markAsRead", notif.id);
      }
      this.$router.push({path: notif.url});
    },
    updateSearchQuery: _.debounce(function(string) {
      this.fetchItems()
    }, 2000),
    fetchItems(page, per_page = null){
      let payload = {page: page || 1, per_page: per_page || this.itemsPerPage,
        ...this.sortBy
      }
      if(this.searchQuery){ payload.search = this.searchQuery }
      if(this.defaultStatus){ payload.status = this.defaultStatus }

      this.isLoading = true
      this.$store.dispatch("notification/fetchNotifications", payload)
      .then(response => {
        this.isLoading = false
        if(response.data.success){
          this.initializeAll();
        }
      })
    },
    deleteItems() {
      if(!this.selectedItems.length){
        this.alertError("You have not selected any item."); return;
      }
      this.confirmDelete({
        text: `You are about to delete ${this.selectedItems.length} notification${this.selectedItems.length > 1 ? 's':'' }`,
      }).then((result) => {
        if (result.value) {
          const formData = new FormData()
          formData.append('data', JSON.stringify({items: this.selectedItems}))
          this.$store.dispatch("changeLoaderValue",true)
          this.$http.post('/notifications/delete', formData)
          .then(response => {
            this.$store.dispatch("changeLoaderValue",false)
            if(response.data.success){
              this.fetchItems()
            }
          })
        }
      });
    },
    initializeAll(){
      this.selectedItems = [];
      this.lastCheckedIndex = null
    }
  },
}

</script>

